'use client'
import PlusIcon from '@/components/icons/PlusIcon'
import Card from '@/components/ui/Card'
import ImageWithFallback from '@/components/ui/ImageWithFallback'
import { IMAGES_BACKEND_URL } from '@/utils/constants'
import { Project } from '@/utils/types/Project'
import { Link } from '@/i18n/routing'
import { FC } from 'react'

export type projectInfo = {
  id: string
  project_name: string
  slug: string
  image_src: string
}

type ProjectCardProps = {
  project: Project
}

const ProjectCard: FC<ProjectCardProps> = ({ project }) => {
  return (
    <Link href={{ pathname: '/projekte/[slug]', params: { slug: project.slug } }} className="col-span-1 md:col-span-2 lg:col-span-4">
      <Card className="min-h-72 lg:min-h-100 overflow-hidden relative rounded-2xl grow p-5">
        <div className="z-20 absolute top-0 left-0 w-full h-full opacity-0 hover:opacity-25 bg-white transition-opacity" />
        <PlusIcon size={20} className="text-accent z-30 w-5 h-5 " />
        <ImageWithFallback
          fill
          className="z-10 w-full h-auto object-cover"
          src={IMAGES_BACKEND_URL + 'projects/' + project.id + '/' + project.main_image}
          fallbackSrc="/images/mocks/mock-bg.jpg"
          sizes="80vw"
          alt={`Image that representing ${project.name}`}
        />
      </Card>
      <h3 className="mt-8 text-white text-2xl leading-6 font-light">{project.name}</h3>
    </Link>
  )
}

export default ProjectCard
